<mat-form-field class="example-chip-list" appearance="outline" [formGroup]="myForm">
    <input
        #tagInput
        [(ngModel)]="searchText"
        [formControl]="search"
        [matAutocomplete]="auto"
        [matChipInputFor]="chipList"
        [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
        placeholder="+ Dodajte učesnike...">
    <mat-chip-list #chipList aria-label="Tag selection">
        <mat-chip class="mt-3"
                  *ngFor="let tag of assignedTags"
                  [selectable]="selectable"
                  [removable]="removable"
                  (removed)="remove(tag)">
            <div class="wd-assigned-options" style="margin-top: 0px">
                <app-avatar [avatarWidth]="36"
                            [assigned]="tag">

                </app-avatar>
            </div>
            <div class="float-left">
                {{tag.full_name}}
            </div>
            <mat-icon *ngIf="removable"
                      matChipRemove>
                cancel
            </mat-icon>
        </mat-chip>

    </mat-chip-list>
    <mat-autocomplete #auto="matAutocomplete"
                      (optionSelected)="selected($event);">
        <mat-option *ngFor="let user of users | searchPipe:searchText:'full_name'"
                    [value]="user">
            <div class="wd-assigned-options">
                <app-avatar [avatarWidth]="20"
                            [assigned]="user"></app-avatar>
            </div>
            <div class="float-left">
                {{user.full_name}}
            </div>
        </mat-option>
    </mat-autocomplete>
    <div style="width: 120px;margin-top: 0.25rem;margin-left:4px;font-size: 80%;color: #dc3545"
         *ngIf="myForm.get('assigned').invalid && myForm.get('assigned').touched">
        Ovo polje je obavezno.
    </div>
</mat-form-field>
